import {
  denormalizeOptionalFields,
  normalizeFormDefaults,
  OptionalKeysArrays,
  WithStringifiedKeys,
} from '../../../../shared/helpers/formNormalization';
import { ApiForwardingRuleCreate } from '../../../../shared/types/ForwardingRule';

export type ForwardingRuleFormValues = WithStringifiedKeys<
  ApiForwardingRuleCreate,
  'key' | 'destination' | 'platform'
>;

const optionalKeys = {
  string: ['destination', 'platform'],
  number: ['key'],
} as const satisfies OptionalKeysArrays<ForwardingRuleFormValues>;

const forwardingRuleFormDefaults: ForwardingRuleFormValues = {
  action: 'FORWARD',
  applyGroup: false,
  enabled: true,
  externalOnly: false,
  preserveId: true,
  screeningEnabled: false,
  timeInterval: '',
  type: 'forwardingrule',
  key: '',
  destination: '',
  platform: '',
};

export const normalizeForwardingRuleFormDefaults = (
  entry?: ApiForwardingRuleCreate,
  defaultOverrides?: Partial<ForwardingRuleFormValues>,
): ForwardingRuleFormValues => {
  return normalizeFormDefaults(
    { ...forwardingRuleFormDefaults, ...(defaultOverrides || {}) },
    entry,
    [...optionalKeys.string, ...optionalKeys.number],
  );
};

export const denormalizeForwardingRuleFormValues = (
  values: ForwardingRuleFormValues,
): ApiForwardingRuleCreate => {
  const normalized = denormalizeOptionalFields(values, optionalKeys);

  return normalized;
};
